module.exports = __webpack_public_path__ + "img/placeholder.0e4b0a7d.jpg";